import { Input } from 'reactstrap';
import NInput from './input.style';

const NoodleInput = NInput(Input);
export default NoodleInput;
